// extracted by mini-css-extract-plugin
export default {"row":"schnEiSeZ380MP9nU1ny"};